import { render } from "./Dashborad.vue?vue&type=template&id=e7083cae&scoped=true"
import script from "./Dashborad.vue?vue&type=script&lang=js"
export * from "./Dashborad.vue?vue&type=script&lang=js"

import "./Dashborad.vue?vue&type=style&index=0&id=e7083cae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7083cae"]])

export default __exports__